import { AdmService } from 'src/app/shared/services/adm.service';
import { Compania } from 'src/app/shared/models/compania';
import { Component, OnInit, ViewChild, AfterViewInit, Inject } from '@angular/core';
import { ConfigService } from 'src/app/shared/services/config.service';
import { defaultValueOrRangeValidator, isMobile, isMobileXL, toFormData } from 'src/app/shared/utils/helpers';
import { Division } from 'src/app/shared/models/division';
import { forkJoin } from 'rxjs';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, NgForm, Validators } from '@angular/forms';
import { LoggedService } from 'src/app/shared/services/logged.service';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { Pais } from 'src/app/shared/models/pais';
import { Region } from 'src/app/shared/models/region';
import { Router } from '@angular/router';
import { SalesOrg } from 'src/app/shared/models/salesOrg';
import { SidenavService } from 'src/app/shared/services/sidenav.service';
import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { TablasService } from 'src/app/shared/services/tablas.service';
import { AutorizacionDtoDisc } from 'src/app/shared/models/autorizacionDtoDisc';
import { IdentityRole } from 'src/app/shared/models/identityRole';
import { ItemParametro } from 'src/app/shared/models/itemparametro';
import { ParametrosService } from 'src/app/shared/services/parametros.service';
import { UsuariosService } from 'src/app/shared/services/usuarios.service';
import { AutorizacionNC } from 'src/app/shared/models/autorizacionNC';
import { TipoNC } from 'src/app/shared/models/tipoNC';
import { NCService } from 'src/app/shared/services/nc.service';


@Component({
  selector: 'app-autorizaciones-nc-dialog',
  templateUrl: './autorizaciones-nc-dialog.component.html'
})
export class AutorizacionesNCDialogComponent {
  a: AutorizacionNC;
  cargos: IdentityRole[] = [];
  codigoEdit: number = -1;
  companias: Compania[] = [];
  divisiones: Division[] = [];
  form: FormGroup;
  idTipo: number;
  mensaje: number = 0;
  salesOrgs: SalesOrg[] = [];
  tipoNCSeleccionado: TipoNC;
  tiposNC: TipoNC[] = [];
  salesOrgSeleccionada: SalesOrg;
  divisionSeleccionada: Division;
  companiaSeleccionada: Compania;

  constructor(private admService: AdmService,
    private configService: ConfigService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<AutorizacionesNCDialogComponent>,
    private fb: FormBuilder,
    private loggedService: LoggedService,
    private router: Router,
    private sidenav: SidenavService,
    private parametrosService: ParametrosService,
    private ncService: NCService,
    private snackBarService: SnackbarService,
    private usuariosService: UsuariosService,
    private tablasService: TablasService,
    @Inject(MAT_DIALOG_DATA) private data: any) {
    this.form = this.fb.group({
      autor: [''],
      cargoAutorizante: ['', Validators.required],
      fechaActualizacion: [new Date()],
      fechaCreacion: [new Date()],
      habilitacion: [true],
      idCargoAutorizante: [''],
      idCompania: ['', Validators.required],
      idDivision: ['', Validators.required],
      idNivel: ['', Validators.required],
      idPais: [''],
      idSalesOrg: ['', Validators.required],
      idTipoNC: ['', Validators.required],
      importe: [0, [Validators.required, Validators.min(1)]],
      nivel: ['', Validators.required],
      tipoNC: [''],
      nivelVendedor: [false],
      validarImporte: [false],
      validarMenor365: [false],
      noApruebaAnteriores: [false],
      validarTipoNC: [false],
      usuarioRedUltimaActualizacion: [''],
      codigo: [0]
    })
    if (data.idTipo != null) {
      this.idTipo = data.idTipo;
    }
    if (data.a != null) {
      this.codigoEdit = data.a.codigo
      this.a = data.a

    }
  }

  public Etiquetas: {

    CargoAutorizante: string,
    Compania: string,
    Habilitacion: string,
    IdDivision: string,
    IdNivel: string,
    Importe: string,
    Nivel: string,
    SalesOrg: string,
    TipoNC: string,
    NoApruebaAnteriores: string,
    ValidarImporte: string,
    ValidarTipoNC: string,
    ValidarMenor365: string,
    NivelVendedor: string,
  }

  public Validaciones: {
    Importe: string
    IdDivision: string
    CargoAutorizante: string
    IdTipoNC: string
    IdNivel: string,
    Nivel: string,
  }

  ngOnInit(): void {
    this.dialogRef.beforeClosed().subscribe(() => this.dialogRef.close(this.mensaje));
    this.Etiquetas = {
      CargoAutorizante: this.configService.etiquetas.CargoAutorizante,
      Compania: this.configService.etiquetas.Compania,
      Habilitacion: this.configService.etiquetas.Habilitacion,
      IdDivision: this.configService.etiquetas.Division,
      IdNivel: this.configService.etiquetas.IdNivel,
      Importe: this.configService.etiquetas.Importe,
      Nivel: this.configService.etiquetas.Nivel,
      NivelVendedor: this.configService.etiquetas.NivelVendedor,
      NoApruebaAnteriores: this.configService.etiquetas.NoApruebaAnteriores,
      SalesOrg: this.configService.etiquetas.SalesOrg,
      TipoNC: this.configService.etiquetas.NotasCredito.TipoNC,
      ValidarImporte: this.configService.etiquetas.ValidarImporte,
      ValidarMenor365: this.configService.etiquetas.ValidarMenor365,
      ValidarTipoNC: this.configService.etiquetas.ValidarTipoNC
    }

    this.Validaciones = {

      IdDivision: this.configService.validaciones.Division,
      IdTipoNC: this.configService.validaciones.NotasCredito.IdTipoNC,
      CargoAutorizante: this.configService.validaciones.Usuarios.Dialog.Rol,
      IdNivel: this.configService.validaciones.Id,
      Nivel: this.configService.validaciones.Descripcion,
      Importe: this.configService.validaciones.Importe

    }
    forkJoin([

      this.admService.cCompanias(this.loggedService.logged.idPais),
      this.admService.cSalesOrgs(this.loggedService.logged.idPais, this.loggedService.logged.idCompania),
      this.admService.cDivisiones(this.loggedService.logged.idPais, this.loggedService.logged.idCompania, this.loggedService.logged.idSalesOrg, this.loggedService.logged.userName),
      this.admService.cTiposNC(this.loggedService.logged.idPais, true),
      this.usuariosService.cRoles(),
      this.tablasService.cAutorizacionNCDB(this.codigoEdit)

    ]).subscribe((data: [Compania[], SalesOrg[], Division[], TipoNC[], IdentityRole[], AutorizacionNC]) => {

      this.form.get('validarImporte').valueChanges.subscribe(() => {
        if (this.form.get('validarImporte').value != null) {
          if (this.form.get('validarImporte').value == true) {
            this.form.get('importe').setValidators([Validators.required, Validators.min(1)]);
          }
          else {
            this.form.get('importe').clearValidators();
            this.form.get('importe').setValue(0);
          }
        }
        this.form.get('importe').updateValueAndValidity();
      })

      if (data[0].length) {
        this.companias = data[0];
      }

      if (data[1].length) {
        this.salesOrgs = data[1];
      }
      if (data[2].length) {
        this.divisiones = data[2];
      }
      if (data[3].length) {
        this.tiposNC = data[3];
      }
      if (data[4].length) {
        this.cargos = data[4];
      }

      if (this.idTipo == 1) {
        this.form.controls['autor'].setValue(this.loggedService.logged.userName);
        let paisPlaceHolder: Pais = new Pais();
        paisPlaceHolder.id = this.loggedService.logged.idPais;
        paisPlaceHolder.descripcion = "";
        this.form.controls['idPais'].setValue(paisPlaceHolder.id);
        if (this.companias.length) {
          this.form.controls['idCompania'].setValue(this.companias[0].id);
        }
        if (this.salesOrgs.length) {
          this.form.controls['idSalesOrg'].setValue(this.salesOrgs[0].id);
        }

        if (this.tiposNC.length) {
          this.form.controls['idTipoNC'].setValue(this.tiposNC[0].id);
        }

      }

      if (typeof this.a != 'undefined') {
        if (this.codigoEdit != -1) {
          if (data[5] != null) {


            this.form.controls['autor'].setValue(data[5].autor);
            this.form.controls['cargoAutorizante'].setValue(data[5].cargoAutorizante);
            this.form.controls['codigo'].setValue(data[5].codigo);
            this.form.controls['habilitacion'].setValue(data[5].habilitacion);
            this.form.controls['idCompania'].setValue(data[5].idCompania);
            this.form.controls['idDivision'].setValue(data[5].idDivision);
            this.form.controls['idNivel'].setValue(data[5].idNivel);
            this.form.controls['idPais'].setValue(data[5].idPais);
            this.form.controls['idSalesOrg'].setValue(data[5].idSalesOrg);
            this.form.controls['idTipoNC'].setValue(data[5].idTipoNC);
            this.form.controls['importe'].setValue(data[5].importe);
            this.form.controls['nivel'].setValue(data[5].nivel);
            this.form.controls['nivelVendedor'].setValue(data[5].nivelVendedor);
            this.form.controls['validarTipoNC'].setValue(data[5].validarTipoNC);
            this.form.controls['validarMenor365'].setValue(data[5].validarMenor365);
            this.form.controls['validarImporte'].setValue(data[5].validarImporte);
            this.form.controls['noApruebaAnteriores'].setValue(data[5].noApruebaAnteriores);


            this.seleccionarTipoNC(this.form.controls['idTipoNC'].value);
            this.form.markAsUntouched();
            this.form.markAsPristine();
          }
        }
      }
      this.seleccionarCompania(this.form.controls['idCompania'].value);
      this.seleccionarSalesOrg(this.form.controls['idSalesOrg'].value);
      this.seleccionarTipoNC(this.form.controls['idTipoNC'].value);
      this.form.controls['usuarioRedUltimaActualizacion'].setValue(this.loggedService.logged.userName);


    });
  }
  compareCompanias(cLista: any, cA: any): boolean {
    if (typeof cLista != 'undefined' && typeof cA != 'undefined') {

      return cLista === cA;
    }
  }

  compareSalesOrgs(salesOrgLista: any, salesOrg: any): boolean {
    if (typeof salesOrgLista != 'undefined' && typeof salesOrg != 'undefined') {

      return salesOrgLista === salesOrg;
    }
  }
  compareDivisiones(divisionLista: any, d: any): boolean {
    if (typeof divisionLista != 'undefined' && typeof d != 'undefined') {

      return divisionLista === d;
    }
  }
  compareCargos(cLista: any, cA: any): boolean {
    if (typeof cLista != 'undefined' && typeof cA != 'undefined') {

      return cA === cLista;
    }
  }
  compareTiposNC(idLista: any, idItem: any): boolean {
    if (typeof idLista != 'undefined' && typeof idItem != 'undefined') {

      return idLista === idItem;
    }
  }

  guardar() {

    switch (this.idTipo) {
      case 1:

        this.tablasService.aAutorizacionNC(this.form.value).subscribe((data: boolean) => {
          this.mensaje = this.idTipo;
          this.dialogRef.close();
        })
        break;

      case 2:

        this.tablasService
          .mAutorizacionNC(this.form.value)
          .subscribe((data: boolean) => {
            this.mensaje = this.idTipo;
            this.dialogRef.close();
          });
        break;
    }

  }
  seleccionarCompania(c: any) {

    this.companiaSeleccionada = null;

    if (c != null) {
      this.companiaSeleccionada = this.companias.find(c => c.id == this.form.controls['idCompania'].value);
    }
  }

  seleccionarSalesOrg(s: any) {

    this.salesOrgSeleccionada = null;

    if (s != null) {
      this.salesOrgSeleccionada = this.salesOrgs.find(c => c.id == this.form.controls['idSalesOrg'].value);
    }
  }

  seleccionarDivision(s: any) {

    this.divisionSeleccionada = null;

    if (s != null) {
      this.divisionSeleccionada = this.divisiones.find(c => c.id == this.form.controls['idDivision'].value);
    }
  }

  seleccionarTipoNC(t: any) {

    this.tipoNCSeleccionado = null;
    this.form.controls['tipoNC'].reset();
    if (t != null) {
      this.tipoNCSeleccionado = this.tiposNC.find(c => c.id == this.form.controls['idTipoNC'].value);
      if (this.tipoNCSeleccionado != null) {
        this.form.controls['tipoNC'].setValue(this.tipoNCSeleccionado.descripcion);
      }
    }
  }

  isMobileXL() {
    return isMobileXL();
  }

  isMobile() {
    return isMobile();
  }

  clearInput(formControlName: string) {
    this.form.controls[formControlName].reset();
  }

  isInRole(rol: string): boolean {
    return this.loggedService.isInRole(rol);
  }
}
